/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CreateReviewInput = {
    comment?: string | null;
    completion?: number | null;
    goalArchived?: boolean | null;
    goalId: string;
    nextReviewAt: string;
    spacedRepetitionLevel?: number | null;
    status: number;
};
export type useCreateReviewMutationVariables = {
    input: CreateReviewInput;
    first?: number | null;
    after?: string | null;
    last?: number | null;
    before?: string | null;
};
export type useCreateReviewMutationResponse = {
    readonly createReview: {
        readonly review: {
            readonly id: string;
            readonly automatedReview: boolean | null;
            readonly completion: number | null;
            readonly comment: string | null;
            readonly createdAt: string;
            readonly updatedAt: string;
        };
        readonly goal: {
            readonly id: string;
            readonly completion: number | null;
            readonly spacedRepetitionLevel: number;
            readonly nextReviewAt: string;
            readonly updatedAt: string;
            readonly " $fragmentRefs": FragmentRefs<"GoalDetailsOverview_goal">;
        };
    };
};
export type useCreateReviewMutation = {
    readonly response: useCreateReviewMutationResponse;
    readonly variables: useCreateReviewMutationVariables;
};



/*
mutation useCreateReviewMutation(
  $input: CreateReviewInput!
  $first: Int
  $after: String
  $last: Int
  $before: String
) {
  createReview(input: $input) {
    review {
      id
      automatedReview
      completion
      comment
      createdAt
      updatedAt
    }
    goal {
      id
      completion
      spacedRepetitionLevel
      nextReviewAt
      updatedAt
      ...GoalDetailsOverview_goal
    }
  }
}

fragment GoalDetailsCompletion_goal on Goal {
  ...GoalStatusField_goal
}

fragment GoalDetailsCurrentReview_goal on Goal {
  currentReviewAt
}

fragment GoalDetailsDescription_goal on Goal {
  id
  description
}

fragment GoalDetailsDueDate_goal on Goal {
  id
  dueDate
}

fragment GoalDetailsNextReview_goal on Goal {
  nextReviewAt
}

fragment GoalDetailsOverview_goal on Goal {
  type
  archived
  ...GoalDetailsNextReview_goal
  ...GoalDetailsCurrentReview_goal
  ...GoalDetailsCompletion_goal
  ...GoalDetailsReviews_goal
  ...GoalDetailsTitleDescription_goal
  ...GoalDetailsDueDate_goal
}

fragment GoalDetailsReviews_goal on Goal {
  ...ReviewCard_goal
  nextReviewAt
  reviews(first: $first, after: $after, last: $last, before: $before) {
    edges {
      node {
        ...ReviewCard_review
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}

fragment GoalDetailsTitleDescription_goal on Goal {
  type
  archived
  ...GoalDetailsTitle_goal
  ...GoalDetailsDescription_goal
}

fragment GoalDetailsTitle_goal on Goal {
  id
  title
}

fragment GoalStatusField_goal on Goal {
  type
  status
  completion
  currentReviewAt
}

fragment GoalStatusField_review on Review {
  status
  completion
  createdAt
}

fragment ReviewCardMenuDeleteItem_goal on Goal {
  id
}

fragment ReviewCardMenuDeleteItem_review on Review {
  id
}

fragment ReviewCardMenu_goal on Goal {
  ...ReviewCardMenuDeleteItem_goal
}

fragment ReviewCardMenu_review on Review {
  ...ReviewCardMenuDeleteItem_review
}

fragment ReviewCard_goal on Goal {
  type
  ...GoalStatusField_goal
  ...ReviewCardMenu_goal
}

fragment ReviewCard_review on Review {
  id
  completion
  comment
  automatedReview
  createdAt
  ...GoalStatusField_review
  ...ReviewCardMenu_review
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "automatedReview",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Review",
  "kind": "LinkedField",
  "name": "review",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spacedRepetitionLevel",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextReviewAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateReviewResponse",
        "kind": "LinkedField",
        "name": "createReview",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GoalDetailsOverview_goal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateReviewResponse",
        "kind": "LinkedField",
        "name": "createReview",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v8/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "archived",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentReviewAt",
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ReviewConnection",
                "kind": "LinkedField",
                "name": "reviews",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReviewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Review",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GoalDetailsReviews_reviews",
                "kind": "LinkedHandle",
                "name": "reviews"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0f1580db2c91807a4791015e467b67c",
    "id": null,
    "metadata": {},
    "name": "useCreateReviewMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateReviewMutation(\n  $input: CreateReviewInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n) {\n  createReview(input: $input) {\n    review {\n      id\n      automatedReview\n      completion\n      comment\n      createdAt\n      updatedAt\n    }\n    goal {\n      id\n      completion\n      spacedRepetitionLevel\n      nextReviewAt\n      updatedAt\n      ...GoalDetailsOverview_goal\n    }\n  }\n}\n\nfragment GoalDetailsCompletion_goal on Goal {\n  ...GoalStatusField_goal\n}\n\nfragment GoalDetailsCurrentReview_goal on Goal {\n  currentReviewAt\n}\n\nfragment GoalDetailsDescription_goal on Goal {\n  id\n  description\n}\n\nfragment GoalDetailsDueDate_goal on Goal {\n  id\n  dueDate\n}\n\nfragment GoalDetailsNextReview_goal on Goal {\n  nextReviewAt\n}\n\nfragment GoalDetailsOverview_goal on Goal {\n  type\n  archived\n  ...GoalDetailsNextReview_goal\n  ...GoalDetailsCurrentReview_goal\n  ...GoalDetailsCompletion_goal\n  ...GoalDetailsReviews_goal\n  ...GoalDetailsTitleDescription_goal\n  ...GoalDetailsDueDate_goal\n}\n\nfragment GoalDetailsReviews_goal on Goal {\n  ...ReviewCard_goal\n  nextReviewAt\n  reviews(first: $first, after: $after, last: $last, before: $before) {\n    edges {\n      node {\n        ...ReviewCard_review\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment GoalDetailsTitleDescription_goal on Goal {\n  type\n  archived\n  ...GoalDetailsTitle_goal\n  ...GoalDetailsDescription_goal\n}\n\nfragment GoalDetailsTitle_goal on Goal {\n  id\n  title\n}\n\nfragment GoalStatusField_goal on Goal {\n  type\n  status\n  completion\n  currentReviewAt\n}\n\nfragment GoalStatusField_review on Review {\n  status\n  completion\n  createdAt\n}\n\nfragment ReviewCardMenuDeleteItem_goal on Goal {\n  id\n}\n\nfragment ReviewCardMenuDeleteItem_review on Review {\n  id\n}\n\nfragment ReviewCardMenu_goal on Goal {\n  ...ReviewCardMenuDeleteItem_goal\n}\n\nfragment ReviewCardMenu_review on Review {\n  ...ReviewCardMenuDeleteItem_review\n}\n\nfragment ReviewCard_goal on Goal {\n  type\n  ...GoalStatusField_goal\n  ...ReviewCardMenu_goal\n}\n\nfragment ReviewCard_review on Review {\n  id\n  completion\n  comment\n  automatedReview\n  createdAt\n  ...GoalStatusField_review\n  ...ReviewCardMenu_review\n}\n"
  }
};
})();
(node as any).hash = '48ca551a1e1fb8c38d66bef6fecc9f33';
export default node;
